<template>
  <div id="qyfr">
    <form id="form2" action="" method="post">
      <input name="frType" id="frType2" value="1" type="hidden" />
      <table
        class="listbox1"
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="938"
      >
        <tbody>
          <tr>
            <td style="text-align: right"><b>*</b> 企业类型：</td>
            <td style="width: 260px; height: 25px">
              <div style="height: 35px">
                <div
                  style="width: 260px; line-height: 32px; font-family: Tahoma"
                  id="usertype"
                >
                  <div style="width: 80px; float: left">
                    <input
                      class="inputcheck"
                      id="chkClass12"
                      type="checkbox"
                      name="chkClass12"
                      value="B"
                    />
                    供应商
                  </div>
                  <div style="width: 90px; float: left">
                    <input
                      class="inputcheck"
                      id="chkClass13"
                      type="checkbox"
                      name="chkClass13"
                      value="A"
                    />
                    代理机构
                  </div>
                  <div style="width: 80px; float: left">
                    <input
                      class="inputcheck"
                      id="chkClass11"
                      type="checkbox"
                      name="chkClass11"
                      value="T"
                    />
                    <span id="TipsShow">采购人</span>
                  </div>
                </div>
              </div>
            </td>
            <td>&nbsp;<input type="hidden" id="CustClass" value="" /></td>
          </tr>

          <tr>
            <td align="right" height="45" width="150"><b>*</b> 企业名称：</td>
            <td style="width: 260px">
              <div class="input-box w260" style="height: 35px">
                <input
                  id="CustomerName"
                  name="CustomerName"
                  data-maxlength="90"
                  class="login_txt width280 required maxlength"
                  data-required-message="请输入企业全称"
                  type="text"
                />
              </div>
            </td>
            <td align="left">
              <span style="font-size: 9pt; color: #ff6600"
                >必须与营业执照、单位公章上名称一致</span
              >
            </td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 用户代码类型：</td>
            <td style="width: 260px">
              <input
                name="txtcomCodeType"
                type="hidden"
                value=""
                id="txtcomCodeType"
              />
              <div id="divselect">
                <select
                  id="UserCodeType"
                  class="login_txt"
                  style="height: 35px; width: 290px"
                >
                  <option value="统一社会信用代码">统一社会信用代码</option>
                </select>
              </div>
            </td>
            <td></td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 用户代码：</td>
            <td style="width: 260px">
              <div
                class="input-box"
                style="height: 35px; width: 255px; top: 0px; left: 0px"
              >
                <input
                  id="ComId"
                  maxlength="18"
                  name="ComId"
                  class="login_txt width280 required"
                  data-required-message="请输入18位的统一社会信用代码"
                  type="text"
                />
              </div>
            </td>
            <td align="left">
              <span style="font-size: 9pt; color: #ff6600"
                >输入18位的统一社会信用代码</span
              >
            </td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 信息申报责任人：</td>
            <td style="width: 260px">
              <div class="input-box" style="height: 35px; width: 255px">
                <input
                  id="contactName"
                  name="contactName"
                  class="login_txt width280 required"
                  data-required-message="请输入信息申报责任人"
                  type="text"
                />
              </div>
            </td>
            <td align="left">
              <span style="font-size: 9pt; color: #ff6600"
                >须输入真实姓名，负责与电子交易平台的联络</span
              >
            </td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 责任人手机号码：</td>
            <td>
              <div class="input-box" style="height: 35px; width: 255px">
                <input
                  id="contactMb"
                  maxlength="11"
                  name="contactMb"
                  class="login_txt width280 required"
                  data-required-message="请输入责任人手机号码"
                  type="text"
                />
              </div>
            </td>
            <td align="left">
              <span style="font-size: 9pt; color: #ff6600"
                >须准确填写,今后在重置密码时用于接收验证码短信</span
              >
            </td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 登录密码：</td>
            <td>
              <div class="input-box" style="height: 35px; width: 255px">
                <input
                  id="txtpwd1"
                  name="txtpwd1"
                  maxlength="20"
                  class="login_txt width280 required"
                  data-required-message="请输入登录密码"
                  type="password"
                />
              </div>
            </td>
            <td align="left">
              <span style="font-size: 9pt; color: #ff6600"
                >6-20个字符，须包含字母和数字，区分大小写</span
              >
            </td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 确认密码：</td>
            <td>
              <div class="input-box" style="height: 35px; width: 255px">
                <input
                  id="txtpwd2"
                  name="txtpwd2"
                  maxlength="20"
                  class="login_txt width280 required"
                  data-required-message="请输入确认密码"
                  type="password"
                />
              </div>
            </td>
            <td></td>
          </tr>

          <tr>
            <td align="right" height="45"><b>*</b> 验证码：</td>
            <td>
              <div class="input-box" style="height: 35px; float: left">
                <input
                  id="ValidNumber"
                  name="ValidNumber"
                  maxlength="4"
                  class="required login_txt"
                  data-required-message="请输入验证码"
                  style="width: 162px; margin-right: 8px"
                  type="text"
                />
              </div>
              <img
                id="imgChkCode"
                :src="VerificationCode"
                @click="CodeChange()"
                style="cursor: pointer; float: left; border-radius: 3px"
                alt=""
              />
            </td>
            <td align="left">
              <a href="javascript:void(0)" @click="CodeChange()"
                >看不清？换一张</a
              >
            </td>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td align="center">
              <input
                id="btnreg"
                value="创建用户"
                class="btn btn-primary"
                style="
                  width: 290px;
                  margin-top: 10px;
                  font-size: 16px;
                  font-weight: bold;
                "
                type="button"
              />
            </td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <div align="center">
        <span class="tipBox"></span>
      </div>
    </form>
  </div>
</template>

<script>
// import { CheckCode } from "@/api/register";
export default {
  data() {
    return {
      VerificationCode: "https://localhost:44362/api/Account/CheckCode",
      registerData: {},

      //登录成功后重定向地址
    };
  },
  methods: {
    CodeChange() {
      this.VerificationCode =
        "https://localhost:44362/api/Account/CheckCode?t=" +
        new Date().valueOf();
    },
  },
};
</script>

<style>
.zuo {
  float: left;
  width: 1000px;
}

.zuo_child {
  float: left;
  width: 300px;
}

.checkinput {
  position: relative;
}

.listbox1 {
  margin: auto;
  font-size: 14px;
  padding-left: 160px;
}
.listbox1 td:last-child {
  padding-left: 8px;
}
a {
  color: #1890ff;
}
a:hover {
  color: #40a9ff;
}
.inputcheck {
  width: 16px;
  height: 16px;
  cursor: pointer;
  vertical-align: middle;
  margin-top: 0;
}
</style>
